import { render, staticRenderFns } from "./WarrantyService.vue?vue&type=template&id=530b6bd4&scoped=true"
import script from "./WarrantyService.vue?vue&type=script&lang=js"
export * from "./WarrantyService.vue?vue&type=script&lang=js"
import style0 from "./WarrantyService.vue?vue&type=style&index=0&id=530b6bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b6bd4",
  null
  
)

export default component.exports